export default __webpack_public_path__ + "static/media/navbar-icon-invoices.873c97b7.svg";